import {
  Header as BronsonReactHeader,
  Logo,
} from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";

export const Header = () => {
  const { t } = useTranslation();

  return (
    <BronsonReactHeader
      role="banner"
      staticHeader
      logo={
        <Logo
          disableLink
          ariaLabel={process.env.REACT_APP_BRAND}
          title={t("title")}
          aria-hidden={true}
        />
      }
    />
  );
};

export default Header;
